import { render } from "./Filiacao.vue?vue&type=template&id=2639596e&scoped=true"
import script from "./Filiacao.vue?vue&type=script&lang=js"
export * from "./Filiacao.vue?vue&type=script&lang=js"

import "./Filiacao.vue?vue&type=style&index=0&id=2639596e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2639596e"]])

export default __exports__